import styles from './style.styl'
import Section from '../section'

const Who = () => (
  <Section
    className={styles.who}
    title={`who&nbsp;<br /><span class="alt">i</span></span>s&nbsp;<br /><span class="alt">i</span></span>t&nbsp;<br />for`}
    text={`
          Our programme attracts high-calibre delegates from around the world. You will learn alongside with Creative Directors, Heads of UX, Heads of Innovation, Architects and Founders from around the world who share the same passions and face similar challenges.
          <br /><br />
          There are only 30 people in each cohort. The earlier you apply, the better chance you will have to join us in 2025.
    `}
  />
)

export default Who



// WEBPACK FOOTER //
// ./components/who/index.js